import React from 'react';
import CustomPoliciesPage from './Pages/CustomPoliciesPage';

const CustomPoliciesRouter = () => {
    return <CustomPoliciesPage />;
};

export default CustomPoliciesRouter;
